import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { FilterDTO, SortDirection, ThirdPartyUserClientZoneAssignmentClient } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { ZonePathUtil } from '../../zone-path.util';

@Injectable()
export class ThirdPartyUserAssignmentEditZonesSelectorService extends ShowInactiveService implements IAdaptorService {
  public readonly extendedZonePathFieldName = ZonePathUtil.extendedZonePathFieldName;
  public clientId: number = null;

  constructor(private tpuAssignmentClient: ThirdPartyUserClientZoneAssignmentClient) {
    super();
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.tpuAssignmentClient.searchZonesByClient(this.clientId, filters, skip, take, sortBy, sortDirection).pipe(
      tap((result: IPagedItems) => {
        result.items.forEach((item: any) => {
          ZonePathUtil.extendByZonePath(item);
        })
      })
    );
  }

  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

}
